<template>
    <div>
        <div class="bg-cover" style="background-image: url(/images/banner-bg.jpg)">
            <div class="container py-12">
                <h1 class="text-4xl uppercase font-light">{{ page.title }}</h1>
            </div>
        </div>
        <div class="container mb-6">

            <Breadcrumbs :breadcrumbs="[
                {label: 'Home', href: '/'},
                {label: page.title, href: null},
            ]" class="my-6"/>

            <div class="prose max-w-none" v-html="page.body"></div>

        </div>
    </div>
</template>

<script>

import Layout from "@app/Shared/Components/Layout";
import Breadcrumbs from "@app/Shared/Components/Breadcrumbs";
import HasMetaData from "@app/Shared/Mixins/HasMetaData";

export default {

    mixins: [HasMetaData],

    props: {
        page: Object,
    },

    layout: Layout,

    components: {
        Breadcrumbs
    },
};

</script>
